module.exports = __webpack_public_path__ + "static/media/red-trash.30700bcc.svg";